import {Nullish} from '../types/Nullish';

export function isURLDangerous(url: string | Nullish) {
  if (!url) {
    return false;
  }

  if (typeof url !== 'string') {
    return false;
  }

  const lowercased = String(url).toLowerCase();

  // Disabling ESLint no-script-url warning because we're explicitly checking FOR dangerous
  // URL schemes as part of our security validation, not using them unsafely.
  // eslint-disable-next-line no-script-url
  return lowercased.includes('javascript:') || lowercased.includes('html;base64');
}
